import LeadershipSectionLabel from '../leadership/LeadershipSectionLabel'
import { contactFormIntroIcons } from '../icons/ContactFormIntroIcons'

function ContactFormIntro({ section }) {
  const { label, titleLine1, titleAccent, description, highlights = [] } = section

  return (
    <div className="contact-form-block__intro contact-form-intro">
      <span className="contact-form-intro__dots" aria-hidden="true" />
      <span className="contact-form-intro__glow" aria-hidden="true" />

      <div className="contact-form-intro__content">
        <LeadershipSectionLabel variant="red">{label}</LeadershipSectionLabel>
        <h2 className="contact-form-intro__title">
          <span className="contact-form-intro__title-line">{titleLine1}</span>
          <span className="contact-form-intro__title-accent">{titleAccent}</span>
        </h2>
        <span className="contact-form-block__accent" aria-hidden="true" />
        <p className="contact-form-block__lead">{description}</p>
      </div>

      {highlights.length > 0 ? (
        <div className="contact-form-intro__highlights" role="list">
          {highlights.map((item, index) => {
            const Icon = contactFormIntroIcons[item.icon]
            return (
              <div className="contact-form-intro__highlight-wrap" key={item.id} role="listitem">
                {index > 0 ? <span className="contact-form-intro__divider" aria-hidden="true" /> : null}
                <div className="contact-form-intro__highlight">
                  <span className="contact-form-intro__icon" aria-hidden="true">
                    {Icon ? <Icon /> : null}
                  </span>
                  <strong>{item.title}</strong>
                </div>
              </div>
            )
          })}
        </div>
      ) : null}
    </div>
  )
}

export default ContactFormIntro
